import gql from 'graphql-tag';
import { GetAllPerDiemsApiQuery } from './getAllPerDiemsApi';

const ApprovePerDiemMutation = gql`
  mutation ApprovePerDiem($input: PerDiemApproveInput!) {
    per_diem_approve(input: $input) {
     id
    }
  }
`;

export const approvePerDiemApi = async (client, perDiemId, districtId, perDiemState, userId = null, ticketJobNumber = null, pageState = null) => {
  const variables = {
    input: perDiemId,
  };

  const options = {
    mutation: ApprovePerDiemMutation,
    variables,
    refetchQueries: [
      {
        query: GetAllPerDiemsApiQuery,
        variables: { perDiemState, districtId, userId, ticketJobNumber, ...pageState },
      },
    ],
  };

  const result = await client.mutate(options);
  return {
    result,
  };
};
